import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectOffer } from 'shared/containers/AuthorAsideBrandContainer/selectors/selectors';
import { abUseExperimentsSelector, isAbUseExperimentsActive, selectIsOfferPublished } from 'shared/selectors';
import { EXPERT_OPINION } from 'shared/services/abUseExperiments/experiments';
import { getDealType, isLongtermRent, isSale } from 'shared/utils/deal_type';
import { getOfferType, isCommercial, isNewbuilding, isOldbuilding, isSuburban } from 'shared/utils/offer_type';

export function useExpertOptionEnabled() {
  const experiments = useSelector(abUseExperimentsSelector);
  const offer = useSelector(selectOffer);
  const offerType = getOfferType(offer);
  const dealType = getDealType(offer);
  const { config } = useApplicationContext();
  const activeOffer = useSelector(selectIsOfferPublished);

  const expertOpinionButtonEnabled = config.get<boolean>('frontend-offer-card.expertOpinionButton.Enabled') || false;
  const chatbotGPTEnabled = config.get<boolean>('frontend-chats.chatbotGPT.Enabled') || false;

  const activeGroup = isAbUseExperimentsActive(experiments, EXPERT_OPINION, 'B');

  return Boolean(
    expertOpinionButtonEnabled &&
      chatbotGPTEnabled &&
      activeOffer &&
      ((!isCommercial(offerType) && isLongtermRent(dealType)) ||
        (isSale(dealType) &&
          (isOldbuilding(offerType) || (activeGroup && isNewbuilding(offerType)) || isSuburban(offerType)))),
  );
}
